/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SaveDoctorExtraSpecialty = {
  properties: {
    specialty: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'DoctorSpecialtyType',
      isRequired: true,
    },
    file: {
      type: 'File',
      isRequired: true,
    },
    toDelete: {
      type: 'boolean',
    },
  },
} as const;
